/**
 * Record ids are identifiers, and identifiers in a URL are personal data once
 * they are sitting in someone else's database. Every id in a portal path is
 * replaced by a placeholder before it is sent anywhere, so
 * /portal/v3/operator/MTI6MzQ1/compliance?itemId=OTk6MQ becomes
 * /portal/v3/operator/:id/compliance?itemId=:id and the shape of the page
 * survives while the record does not.
 *
 * Both telemetry sinks use this - Grafana Faro in plugins/rum.js and PostHog in
 * plugins/analytics.js - so a URL cannot be scrubbed for one and leak through
 * the other. Anything added here is covered everywhere at once.
 */
const SCRUB_RULES = [
  { find: /\/(operator|admin|customer)\/[^/?#]+/g, replace: '/$1/:id' },
  { find: /([?&](itemId|employeeId|userId|vehicleId|inspectionId|timesheetId|reportId|companyId)=)[^&#]*/gi, replace: '$1:id' },
  { find: /#\d+:\d+/g, replace: '#:rid' },
];

export const scrubUrl = (url) => {
  if (!url) {
    return url;
  }
  let scrubbed = String(url);
  SCRUB_RULES.forEach((rule) => {
    scrubbed = scrubbed.replace(rule.find, rule.replace);
  });
  return scrubbed;
};

export default scrubUrl;
